import { BusinessLine, EventData, ProductLine } from "@/types/common";

/*
 * This function is used to get the page type and product line based on the URL
 * For cart and checkout it uses the product_gender and sku data
 */
export const getDetailsByPathname = (data?: EventData) => {
  const pathname = typeof window === "object" ? window.location.pathname : "";
  const segments = pathname.split("/").filter(Boolean);
  const isBrand = segments.includes("brand") || ["All", "Unisex"].includes(data?.product_gender);
  const isMen = segments.includes("men") || data?.product_gender === "Men";
  const [category, page_category, page_type_raw, page_details, page_description] = segments;

  // Logic to determine page_type based on segment count or keywords
  let page_type = page_type_raw;

  if (segments.length === 0 || pathname === "/") {
    page_type = "homepage";
  } else if (pathname === "/men/") {
    page_type = "homepage_men";
  } else if (segments.includes("category")) {
    page_type = "pcp";
  } else if (segments.includes("product")) {
    page_type = "pdp";
  } else if (segments.includes("cart")) {
    page_type = "cart";
  } else if (segments.includes("checkout")) {
    page_type = "checkout";
  } else if (segments.includes("quiz")) {
    page_type = "quiz";
  }

  if (!page_type) {
    page_type = "lp";
  }

  const product_line = (isBrand ? "neutral" : isMen ? "men" : "women") as ProductLine;
  const business_line = "Hair" as BusinessLine;
  return {
    isMen,
    category,
    page_category,
    page_description,
    page_details,
    page_type,
    product_line,
    business_line,
  };
};
